import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Header from '../Header';
import BottomSlant from '../../components/BottomSlant';
import OrderStatusErrorPage from '../../components/OrderStatusErrorPage';
import OrderStatusSkeleton from '../../components/OrderStatusSkeleton';

import OrderStatusPolling from '../../utils/orderStatusPolling';
import { getOrderStatus } from '../../actions/orderActions';

import styles from './styles.scss';

const NORMAL_POLLING_INTERVAL_MS = 5000;
const TIMES_POLLED_LIMIT = 6;

// eslint-disable-next-line react/no-deprecated
export class OrderStatusSkeletonContainer extends Component {
  constructor(props) {
    super(props);

    if (!this.polling) {
      this.polling = new OrderStatusPolling({
        pollAction: () => {
          this.props.getOrderStatus(this.props.orderId, this.props.failedAttempts);
        },
        normalPollingIntervalMs: NORMAL_POLLING_INTERVAL_MS,
        timesPolledLimit: TIMES_POLLED_LIMIT,
      });
    }
  }

  componentDidMount() {
    if (this.polling) {
      this.polling.poll();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.status !== nextProps.status && this.polling) {
      this.polling.onUpdate(nextProps, {
        error: nextProps.status.error,
      });
    }
  }

  componentWillUnmount() {
    if (this.polling) {
      this.polling.unmount();
    }
  }

  renderContent() {
    const { orderId, status } = this.props;
    const isUnderPollLimit = this.polling && this.polling.isUnderPollLimit();

    if (!this.polling || isUnderPollLimit) {
      return <OrderStatusSkeleton attributes={status.attributes} orderId={orderId} />;
    }

    clearInterval(this.timer);
    this.timer = null;
    return <OrderStatusErrorPage orderId={orderId} />;
  }

  render() {
    return (
      <div className={styles['order-status-skeleton']}>
        <Header isTransparent logoColor="white" />
        <div className={styles.slant}>
          <BottomSlant colorTheme="teal" />
        </div>
        {this.renderContent()}
      </div>
    );
  }
}

OrderStatusSkeletonContainer.defaultProps = {
  failedAttempts: 0,
};

OrderStatusSkeletonContainer.propTypes = {
  orderId: PropTypes.string.isRequired,
  status: PropTypes.shape({
    error: PropTypes.shape({
      message: PropTypes.string,
      statusCode: PropTypes.number,
    }),
    attributes: PropTypes.shape({
      title: PropTypes.string,
      message: PropTypes.string,
    }),
  }).isRequired,
  getOrderStatus: PropTypes.func.isRequired,
  /*
   How many times consecutively it's tried to fetch the order status
   */
  failedAttempts: PropTypes.number,
};

const mapStateToProps = (state) => {
  const { order, request } = state;
  const status = order.status;
  return {
    status,
    // Get the orderId from the url query so we're not reliant on fetching the order
    orderId: request.currentQuery.orderId,
    failedAttempts: status.failedAttempts,
  };
};

const mapActionsToProps = (dispatch) => ({
  getOrderStatus: (orderId, failedAttempts) => dispatch(getOrderStatus(orderId, failedAttempts)),
});

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(OrderStatusSkeletonContainer);
